import type { AssignmentSuggestion } from '@chukua/common';
import { useState, type KeyboardEvent } from 'react';

/**
 * Arrow keys move through the crews that can be chosen and Enter chooses the active one. Blocked rows are not in the list, so Enter can never
 * choose one. Keys pressed on a button or link inside a row are left to that control, or Enter would choose twice.
 */
export function usePickerKeyboard(crews: AssignmentSuggestion[], onChoose: (crew: AssignmentSuggestion) => void) {
  const [activeIndex, setActiveIndex] = useState(0);
  const lastIndex = Math.max(crews.length - 1, 0);
  const active = Math.min(activeIndex, lastIndex);

  function onKeyDown(event: KeyboardEvent<HTMLElement>): void {
    if (event.target !== event.currentTarget || crews.length === 0) return;
    if (event.key === 'ArrowDown') setActiveIndex(Math.min(active + 1, lastIndex));
    else if (event.key === 'ArrowUp') setActiveIndex(Math.max(active - 1, 0));
    else if (event.key === 'Enter') onChoose(crews[active]);
    else return;
    event.preventDefault();
  }

  return { activeRank: crews[active]?.rank ?? null, onKeyDown };
}
